'use es6';

import PropTypes from 'prop-types';
import MetricLabelFullAccess from './MetricLabelFullAccess';
import MetricLabelLimitedAccess from './MetricLabelLimitedAccess';
import { jsx as _jsx } from "react/jsx-runtime";
export default function MetricLabel({
  metric,
  hasRevenueAttributionLimitedAccess = false,
  learnMoreUrl,
  screen
}) {
  if (hasRevenueAttributionLimitedAccess) {
    return /*#__PURE__*/_jsx(MetricLabelLimitedAccess, {
      metric: metric,
      learnMoreUrl: learnMoreUrl,
      screen: screen
    });
  }
  return /*#__PURE__*/_jsx(MetricLabelFullAccess, {
    metric: metric,
    learnMoreUrl: learnMoreUrl,
    screen: screen
  });
}
MetricLabel.propTypes = {
  metric: PropTypes.string.isRequired,
  hasRevenueAttributionLimitedAccess: PropTypes.bool,
  learnMoreUrl: PropTypes.string,
  screen: PropTypes.string.isRequired
};